export default "__VITE_ASSET__87c589c0__"